import { Component, OnInit } from '@angular/core';
import { ActivationEnd, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { environment } from '@environments/environment';
import { FooterComponent } from '@shared/components/footer/footer.component';
import { HeaderComponent } from '@shared/components/header/header.component';
import { LoaderComponent } from '@shared/components/loader/loader.component';
import { ToastComponent } from '@shared/components/toast/toast.component';
import { TopHeaderComponent } from '@shared/components/top-header/top-header.component';
import { ROUTE_PARAMS } from '@shared/constants/route-param.constants';
import { SITE_LINKS } from '@shared/constants/site-links.constants';

@Component({
  selector: 'avenir-root',
  standalone: true,
  imports: [
    RouterOutlet,
    LoaderComponent,
    ToastComponent,
    HeaderComponent,
    FooterComponent,
    TopHeaderComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  displayComponent = true;
  clientId = environment.CLIENT_ID;
  environmentName = environment.ENV_NAME

  constructor(private router: Router) {}

  ngOnInit(): void {
    // This block fire on URL change and gets the clientId from URL to calculate what kind of user role should be displayed
    // super admin/client admin/customer admin
    this.router.events.subscribe(event => {
      if (event instanceof ActivationEnd) {
        // Activation end fires multiple times depending on how many child routes there are, get any clientId if any
        this.clientId = event.snapshot.params[ROUTE_PARAMS.CLIENT_ID] || this.clientId;
      }
      else if (event instanceof NavigationEnd) {
        // Header/footer handling
        if (
          event.urlAfterRedirects === '/' ||
          event.urlAfterRedirects.match(SITE_LINKS.AUTH.LOGIN)
        ) {
          this.displayComponent = false;
        } else {
          this.displayComponent = true;
        }
      }
    })
  }
}
